import { render, staticRenderFns } from "./EsgBaseDashboard.vue?vue&type=template&id=20a993c9&scoped=true"
import script from "./EsgBaseDashboard.vue?vue&type=script&lang=js"
export * from "./EsgBaseDashboard.vue?vue&type=script&lang=js"
import style0 from "./EsgBaseDashboard.vue?vue&type=style&index=0&id=20a993c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a993c9",
  null
  
)

export default component.exports